/**
 * GA4 初始化、page_view 与 CTA 追踪（WhatsApp/Email/WeChat/手动 .js-cta）
 * 修复内容：
 * 1. getClusterName() 改为从 URL 路径自动推断，不再依赖缺失的 <meta name="cluster">
 * 2. 所有 .js-cta 缺失 data-cta-channel 时 fallback 为 'other' 而非空字符串
 * 3. 新增 WeChat 链接识别（weixin:// 协议 & 常见微信域名）
 * 4. gtag script 建议移至 <head>（见底部注释）
 */
(function () {
  'use strict';

  var GA4_GTAG_MAX_WAIT_MS = 5000;
  var GA4_GTAG_POLL_MS = 80;

  function waitForGtag(callback) {
    var elapsed = 0;
    function check() {
      if (typeof window.gtag === 'function') {
        callback();
        return;
      }
      elapsed += GA4_GTAG_POLL_MS;
      if (elapsed >= GA4_GTAG_MAX_WAIT_MS) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('GA4: gtag 未在 ' + (GA4_GTAG_MAX_WAIT_MS / 1000) + 's 内就绪，跳过初始化');
        }
        return;
      }
      setTimeout(check, GA4_GTAG_POLL_MS);
    }
    check();
  }

  waitForGtag(function () {
    var id = window.ga_measurement_id || 'G-HK4MHQQSR0';

    function s(v) { return (v === undefined || v === null) ? '' : String(v).trim(); }

    function inferPageType(pathname) {
      try {
        var p = (pathname || location.pathname || '/').toLowerCase();
        if (p === '/' || p === '') return 'home';
        if (p.indexOf('/collections/') === 0) return 'collections';
        if (p.indexOf('/pages/') === 0) return 'landing_page';
        if (p.indexOf('/blogs/') === 0) return 'blog';
        if (p.indexOf('/products/') === 0) return 'product';
        if (p.indexOf('/search') === 0) return 'search';
        if (p.indexOf('/contact') >= 0) return 'contact';
        return 'other';
      } catch (e) { return 'other'; }
    }

    /**
     * [修复 1] getClusterName：从 URL 路径推断关键词簇
     * 优先读取 data-cluster 属性（如果开发者手动设置了的话）
     * 否则根据 /pages/ 和 /collections/ URL 自动分类
     */
    function getClusterName() {
      try {
        // 优先读取手动设置的 data-cluster 属性
        var el = document.querySelector('[data-cluster]');
        if (el) {
          var v = el.getAttribute('data-cluster');
          if (v) return String(v).trim();
        }
        // meta 标签备选
        var meta = document.querySelector('meta[name="cluster"]');
        if (meta && meta.content) return String(meta.content).trim();

        // 根据 URL 路径自动推断
        var p = location.pathname.toLowerCase();

        // 产品系列页
        if (p.indexOf('/collections/vertical-form') >= 0 || p.indexOf('/products/vffs') >= 0 || p.indexOf('/products/powder-vffs') >= 0) return 'vffs_machines';
        if (p.indexOf('/collections/powder') >= 0 || p.indexOf('/collections/filling') >= 0) return 'filling_machines';
        if (p.indexOf('/collections/liquid') >= 0 || p.indexOf('/collections/metering') >= 0) return 'liquid_filling';
        if (p.indexOf('/collections/premade') >= 0 || p.indexOf('/collections/pouch') >= 0) return 'premade_pouch';
        if (p.indexOf('/collections/cartoning') >= 0) return 'cartoning_machines';
        if (p.indexOf('/collections/conveying') >= 0) return 'conveying_equipment';
        if (p.indexOf('/collections/weighing') >= 0) return 'weighing_equipment';
        if (p.indexOf('/collections/hrizontal') >= 0 || p.indexOf('/collections/flow') >= 0) return 'flow_wrappers';

        // 落地页
        if (p.indexOf('/pages/powder') >= 0 || p.indexOf('/pages/granule') >= 0) return 'powder_granule';
        if (p.indexOf('/pages/liquid') >= 0 || p.indexOf('/pages/paste') >= 0) return 'liquid_paste';
        if (p.indexOf('/pages/snack') >= 0) return 'snack_food';
        if (p.indexOf('/pages/pharma') >= 0 || p.indexOf('/pages/chemical') >= 0) return 'pharma_chemical';
        if (p.indexOf('/pages/coffee') >= 0 || p.indexOf('/pages/tea') >= 0) return 'coffee_tea';
        if (p.indexOf('/pages/frozen') >= 0) return 'frozen_food';
        if (p.indexOf('/pages/canned') >= 0 || p.indexOf('/pages/pet-food') >= 0) return 'pet_food';
        if (p.indexOf('/pages/glass') >= 0 || p.indexOf('/pages/bottle') >= 0) return 'bottle_packaging';
        if (p.indexOf('/pages/3-side') >= 0 || p.indexOf('/pages/4-side') >= 0 || p.indexOf('/pages/back-seal') >= 0) return 'bag_style';
        if (p.indexOf('/pages/pre-made') >= 0 || p.indexOf('/pages/doypack') >= 0) return 'premade_pouch';
        if (p.indexOf('/pages/parts') >= 0 || p.indexOf('/pages/counting') >= 0) return 'parts_counting';

        return '';
      } catch (e) { return ''; }
    }

    function getUTMParams() {
      if (window.ga_utm && window.ga_utm.utm_source) return window.ga_utm;
      try {
        var params = new URLSearchParams(window.location.search);
        window.ga_utm = {
          utm_source: params.get('utm_source') || '',
          utm_medium: params.get('utm_medium') || '',
          utm_campaign: params.get('utm_campaign') || '',
          utm_content: params.get('utm_content') || '',
          utm_term: params.get('utm_term') || ''
        };
        return window.ga_utm;
      } catch (e) { return {}; }
    }

    function sendPageView() {
      try {
        var page_type = inferPageType(location.pathname);
        var cluster_name = getClusterName();
        var utm = getUTMParams();

        var eventParams = {
          page_title: document.title || '',
          page_location: location.href,
          page_referrer: document.referrer || '',
          page_type: page_type,
          cluster_name: cluster_name,
          country: window.ga_country || '',
          language: window.ga_language || ''
        };

        if (utm.utm_source) {
          eventParams.utm_source = utm.utm_source;
          eventParams.utm_medium = utm.utm_medium;
          eventParams.utm_campaign = utm.utm_campaign;
          eventParams.utm_content = utm.utm_content;
          eventParams.utm_term = utm.utm_term;
        }

        window.gtag('event', 'page_view', eventParams);
      } catch (e) {
        console.error('GA4 page_view error:', e);
      }
    }

    window.inferPageType = inferPageType;
    window.getClusterName = getClusterName;

    window.gtag('js', new Date());
    window.gtag('config', id, {
      send_page_view: false,
      custom_map: {
        'dimension1': 'page_type',
        'dimension2': 'cluster_name',
        'dimension3': 'country',
        'dimension4': 'language',
        'dimension5': 'cta_channel',
        'dimension6': 'cta_position',
        'dimension7': 'cta_label',
        'dimension8': 'link_url'
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sendPageView);
    } else {
      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(sendPageView, { timeout: 2000 });
      } else {
        setTimeout(sendPageView, 0);
      }
    }

    // ---------- CTA 追踪 ----------

    function isWhatsAppLink(href) {
      if (!href || typeof href !== 'string') return false;
      var u = href.trim().toLowerCase();
      return u.indexOf('wa.me/') !== -1 ||
        u.indexOf('api.whatsapp.com') !== -1 ||
        u.indexOf('whatsapp.com') !== -1 ||
        u.indexOf('whatsapp://') === 0;
    }

    function isEmailLink(href) {
      if (!href || typeof href !== 'string') return false;
      return href.trim().toLowerCase().indexOf('mailto:') === 0;
    }

    /**
     * [修复 3] 新增 WeChat 链接识别
     */
    function isWeChatLink(href) {
      if (!href || typeof href !== 'string') return false;
      var u = href.trim().toLowerCase();
      return u.indexOf('weixin://') === 0 ||
        u.indexOf('wx.qq.com') !== -1 ||
        u.indexOf('weixin.qq.com') !== -1;
    }

    function inferPosition(el) {
      if (!el || !el.closest) return 'inline';
      if (el.closest('.floating-contact-sidebar')) return 'sidebar';
      if (el.closest('.mobile-navigation-bar') || el.closest('.mobile-nav-whatsapp')) return 'mobile_menu';
      if (el.closest('.product-single') || el.closest('main .product')) return 'product_page';
      if (el.closest('.product-item') || el.closest('.sec__products-grid')) return 'product_card';
      if (el.closest('.slideshow') || el.closest('.banner-packery') || el.closest('[class*="banner"]')) return 'banner';
      if (el.closest('.footer') || el.closest('footer')) return 'footer';
      if (el.closest('.social-icons') || el.closest('[class*="social"]')) return 'social_icons';
      if (el.closest('.page-faqs') || el.closest('.faq')) return 'faq_page';
      if (el.closest('.product-quickview')) return 'quickview';
      if (el.closest('.minicart') || el.closest('#minicart')) return 'minicart';
      if (el.closest('.rte') || el.closest('.page-content') || el.closest('.rich__text')) return 'inline_content';
      return 'inline';
    }

    function baseParams() {
      var params = {
        page_location: location.href,
        page_referrer: document.referrer || '',
        page_title: document.title || '',
        page_type: inferPageType(location.pathname),
        cluster_name: getClusterName()
      };
      if (window.ga_country) params.country = s(window.ga_country);
      if (window.ga_language) params.language = s(window.ga_language);
      var utm = getUTMParams();
      if (utm.utm_source) {
        params.utm_source = utm.utm_source;
        params.utm_medium = utm.utm_medium;
        params.utm_campaign = utm.utm_campaign;
        params.utm_content = utm.utm_content;
        params.utm_term = utm.utm_term;
      }
      return params;
    }

    function fire(eventName, params) {
      try {
        if (typeof window.gtag === 'function') window.gtag('event', eventName, params || {});
      } catch (e) {
        console.error('GA4 event error:', e);
      }
    }

    var lastSig = '', lastTs = 0;
    function dedupe(sig) {
      var now = Date.now();
      if (sig && sig === lastSig && (now - lastTs) < 1000) return true;
      lastSig = sig;
      lastTs = now;
      return false;
    }

    function sendCta(channel, position, label, linkUrl) {
      var p = baseParams();
      /**
       * [修复 2] channel 缺失时 fallback 为 'other'，防止 GA4 记录空值
       */
      p.cta_channel = (channel && channel !== '') ? channel : 'other';
      p.cta_position = (position && position !== '') ? position : 'unknown';
      p.cta_label = (label && label !== '') ? label : 'cta_click';
      p.link_url = linkUrl || '';
      fire('cta_click', p);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;

      var link = t.closest ? t.closest('a') : null;
      var ctaEl = t.closest ? t.closest('.js-cta') : null;

      if (link) {
        var href = s(link.getAttribute('href') || link.href);
        if (href) {
          var posA = s(link.getAttribute('data-cta-position')) || inferPosition(link);
          var labelA = s(link.getAttribute('data-cta-label')) || s(link.textContent) || posA || 'cta_click';

          if (isWhatsAppLink(href)) {
            var sigA = 'wa|' + href + '|' + posA;
            if (!dedupe(sigA)) {
              sendCta('whatsapp', posA, labelA, href);
            }
            return;
          }
          if (isEmailLink(href)) {
            var sigB = 'em|' + href + '|' + posA;
            if (!dedupe(sigB)) {
              sendCta('email', posA, labelA, href);
            }
            return;
          }
          // [修复 3] WeChat 链接识别
          if (isWeChatLink(href)) {
            var sigW = 'wc|' + href + '|' + posA;
            if (!dedupe(sigW)) {
              sendCta('wechat', posA, labelA, href);
            }
            return;
          }
        }
      }

      if (ctaEl) {
        var channel = s(ctaEl.getAttribute('data-cta-channel'));
        var pos = s(ctaEl.getAttribute('data-cta-position')) || inferPosition(ctaEl);
        var label = s(ctaEl.getAttribute('data-cta-label')) || s(ctaEl.textContent) || pos || 'cta_click';
        var linkUrl = '';
        if (ctaEl.tagName === 'A') linkUrl = s(ctaEl.getAttribute('href') || ctaEl.href);
        var sigC = 'cta|' + channel + '|' + pos + '|' + label;
        if (!dedupe(sigC)) sendCta(channel, pos, label, linkUrl);
      }
    }, true);

  });
})();

/*
 * ============================================================
 * 建议：将以下代码从 body 底部移至 <head> 内，
 * 可避免用户极快点击时 gtag 未就绪导致事件丢失：
 *
 * <script async src="https://www.googletagmanager.com/gtag/js?id=G-HK4MHQQSR0"></script>
 * <script>
 *   window.dataLayer = window.dataLayer || [];
 *   function gtag(){ dataLayer.push(arguments); }
 *   window.ga_measurement_id = 'G-HK4MHQQSR0';
 *   window.ga_country = '{{ request.locale.iso_code }}';
 *   window.ga_language = '{{ request.locale.iso_code }}';
 * </script>
 * ============================================================
 */
